import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
import artistStyles from "views/Artists/Styles/ArtistStyles.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Parallax from "components/Parallax/Parallax.jsx";
import SectionCarousel from "./Sections/DianeEideCarousel.jsx";
import SectionNavbars from "views/Components/Sections/SectionNavbars.jsx";
import componentsStyle from "assets/jss/material-kit-react/views/components.jsx";


import Header from "components/Header/Header.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";



class Components extends React.Component {
  render() {

    const { classes, ...rest } = this.props;


    return (     
      
      <div> 

        <SectionNavbars />
        <Parallax image={require("assets/img/Eide/Cows.jpg")} >       

          <div className={classes.container}>
            <GridContainer>
              <GridItem>
                <div className={classes.brand}>
                  <h1 className={classes.title}>Eide Fine Art</h1>
                  <h4><b>With its display of contemporary ceramics, paintings, and sculpture, the Eide Art Gallery 465 is one of Northern Arizona's finest art venues. Works by recognized fine artists from the United States and other countries are showcased in the gallery. The adobe complex overlooks the Verde River in Lower Sycamore Canyon.</b></h4>
                </div>
              </GridItem>
            </GridContainer>
          </div>
        </Parallax>

        <div className={classNames(classes.main, classes.mainRaised)} >
          <h3 className ={classNames(classes.subtitle)} style={artistStyles.bioText}>
              Diane Eide

             </h3>
          <p style={artistStyles.bioText}>Featured two dimensional artist Diane J. Eide received her undergraduate degree in art from Augustana College, Sioux Falls, South Dakota. Further study was under Vance Kirkland at the University of Denver. She received her masters degree from Northern Arizona University, Flagstaff, Arizona. She taught drawing and art education at NAU and also art in the Flagstaff Public Schools. She has lived, traveled, and painted in England as well as in Asia, and Europe. Utilizing primarily oils,  watercolors, pastels and graphite, she produces works with a broad range of subject-matter, including portraits, still-life’s, landscapes and pure abstracts.  “As an artist, I use ordinary subject matter familiar to all of us.  Through
            editing, simplifying and thoughtful placement of elements, I hope to encourage the viewer to put aside preconceived ideas
            and look at the subjects in a different light.  I use contrast through light and value to lend a sense of drama and give an abstract quality to the painting.</p>

          <SectionCarousel/>
        </div>
        <Footer />
      </div>
    );
  }
}

export default withStyles(componentsStyle)(Components);



// WEBPACK FOOTER //
// ./src/views/Artists/DianeEide.jsx